import { render, staticRenderFns } from "./appheader.vue?vue&type=template&id=273083a5&scoped=true"
import script from "./appheader.vue?vue&type=script&setup=true&lang=js"
export * from "./appheader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./appheader.vue?vue&type=style&index=0&id=273083a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273083a5",
  null
  
)

export default component.exports